export default {"src":"/_next/static/media/PCG.9a37bb2e.svg","height":18,"width":18};